import { dispatchExternalEvent } from '@sbt-web/utils';
import { sendEventToGTM as sendEventToGTM$1 } from '@sbt-web/tracking';
import Cookies from 'js-cookie';
import React from 'react';

const sendEventToGTM = function () {
    window.subito = window.subito || {};
    window.subito.flags = window.subito.flags || {};
    if (window.Didomi.getUserConsentStatus('cookies', '1') &&
        !window.subito.flags.privacyReady) {
        window.subito.flags.privacyReady = true;
        sendEventToGTM$1('gtmPrivacyAccepted');
    }
};

const buildPreferences = (didomiObject) => didomiObject?.getPurposesBasedOnConsent()
    ? didomiObject?.getPurposesBasedOnConsent()?.map((purpose) => ({
        id: purpose.id,
        type: 'Preference',
        value: didomiObject?.getUserConsentStatusForPurpose(purpose.id)
            ? 'agree'
            : 'disagree',
    }))
    : [];
const trackEvent = (pulseInstance, objectId, targetType, pageId) => {
    const didomiObject = window.Didomi;
    const isPageAsTargetType = targetType === 'Page';
    const didomiExperiment = didomiObject?.getExperiment();
    const didomiConfig = didomiObject?.getConfig();
    const abtest = didomiConfig?.experiment !== undefined
        ? `${didomiConfig?.experiment?.id}:`
        : '';
    const label = didomiExperiment !== undefined && didomiExperiment !== null
        ? abtest + didomiExperiment.group
        : undefined;
    const preferences = !isPageAsTargetType
        ? buildPreferences(didomiObject)
        : undefined;
    const target = isPageAsTargetType
        ? { type: targetType, id: pageId }
        : undefined;
    pulseInstance?.queueEvent({
        schema: 'http://schema.adevinta.com/events/tracker-event.json/230.json',
        type: 'Click',
        object: {
            type: isPageAsTargetType ? 'UIElement' : targetType,
            id: objectId,
            elementType: 'button',
            label,
            preferences,
        },
        target,
    });
};

const setCookieForMedallia = () => {
    const newDate = new Date(new Date().setMonth(new Date().getMonth() + 12));
    Cookies.set('displayCookieConsent', 'y', { expires: newDate });
};

const consentChangedListener = () => {
    dispatchExternalEvent('subito:Privacy:Ready');
    sendEventToGTM();
};
const noticeClickagreeListener = (pulseInstance) => {
    setCookieForMedallia();
    trackEvent(pulseInstance, 'agreetoall', 'Page');
};
const noticeClickmoreinfoListener = (pulseInstance) => trackEvent(pulseInstance, 'preferences', 'Page');
const preferencesClickviewvendorsListener = (pulseInstance) => trackEvent(pulseInstance, 'preferences_partners', 'Page');
const preferencesClickdisagreetoallListener = (pulseInstance) => trackEvent(pulseInstance, 'preferences_disagreetoall', 'Page');
const preferencesClickagreetoallListener = (pulseInstance) => {
    setCookieForMedallia();
    trackEvent(pulseInstance, 'preferences_agreetoall', 'Page');
};
const preferencesClicksavechoicesListener = (pulseInstance) => trackEvent(pulseInstance, 'preferences_save', 'GenericPreferences');
const didomiOnReadyListener = (pulseInstance, fromPage) => {
    sendEventToGTM();
    const continueWithoutAccepting = document.querySelector('span.didomi-continue-without-agreeing');
    continueWithoutAccepting?.addEventListener('click', () => trackEvent(pulseInstance, 'disagreetoall', 'Page', fromPage));
};

const getDidomiEvents = (pulseInstance) => [
    {
        event: 'consent.changed',
        listener: consentChangedListener,
    },
    {
        event: 'notice.clickagree',
        listener: () => noticeClickagreeListener(pulseInstance),
    },
    {
        event: 'notice.clickmoreinfo',
        listener: () => noticeClickmoreinfoListener(pulseInstance),
    },
    {
        event: 'preferences.clickviewvendors',
        listener: () => preferencesClickviewvendorsListener(pulseInstance),
    },
    {
        event: 'preferences.clickdisagreetoall',
        listener: () => preferencesClickdisagreetoallListener(pulseInstance),
    },
    {
        event: 'preferences.clickagreetoall',
        listener: () => preferencesClickagreetoallListener(pulseInstance),
    },
    {
        event: 'preferences.clicksavechoices',
        listener: () => preferencesClicksavechoicesListener(pulseInstance),
    },
];

const init = (pulseInstance, fromPage) => {
    window.didomiEventListeners = window.didomiEventListeners || [];
    window.didomiOnReady = window.didomiOnReady || [];
    window.didomiEventListeners.push(...getDidomiEvents(pulseInstance));
    window.didomiOnReady.push(() => didomiOnReadyListener(pulseInstance, fromPage));
};

function didomiScriptElements(props) {
    const stageNotice = 'Qr9rmDEt';
    const sdkParams = props.env === 'prod'
        ? 'target=www.subito.it'
        : `target_type=notice&target=${stageNotice}`;
    const sdkUrl = `https://sdk.privacy-center.org/bd1597a9-9e29-4189-bc67-064d912dff5d/loader.js?${sdkParams}`;
    const ScriptComponent = props.nextJsScriptComponent;
    // To fix hydration issue after migrated to App router, we need to use Script component from next/script
    if (ScriptComponent) {
        return [
            React.createElement(ScriptComponent, { dangerouslySetInnerHTML: {
                    __html: 'window.gdprAppliesGlobally=true;',
                }, key: "didomi-config" }),
            React.createElement(ScriptComponent, { src: sdkUrl, async: true, key: "didomi-script" }),
        ];
    }
    // Fallback and deprecated way to use Script component from next/script
    return [
        React.createElement("script", { dangerouslySetInnerHTML: {
                __html: 'window.gdprAppliesGlobally=true;',
            }, key: "didomi-config" }),
        React.createElement("script", { src: sdkUrl, 
            // @ts-expect-error react/no-unknown-property
            fetchPriority: "high", async: true, key: "didomi-script" }),
    ];
}

export { didomiScriptElements, init as initDidomi };
//# sourceMappingURL=index.js.map
